import cosmeticsCategories, { CosmeticsCategories } from 'common/helpers/constants/cosmeticsCategories'
import cosmeticsProductTypes from 'common/helpers/constants/cosmeticsProductTypes'


type RootName     = keyof CosmeticsCategories
type CategoryName = keyof UnionToIntersection<ValueOf<CosmeticsCategories>['categories']>

type SubCategory = {
  name?: string
  [key: string]: any
}

type Category = {
  name?: CategoryName
  subCategories?: SubCategory[]
  [key: string]: any
}

type Type = object

/**
 * Check if the "root" value exists in contants
 */
const checkRoot = (root: RootName): boolean => {
  const isExist = root in cosmeticsCategories

  if (!isExist) {
    console.error('Error in getCosmeticsCategories helper: incorrect "root" argument')
  }

  return isExist
}

const checkCategory = (root: RootName, category: CategoryName): boolean => {
  const isExist = cosmeticsProductTypes[root][category]

  if (!isExist) {
    const error = Boolean(category)
      ? `not exist category: "${category}" in cosmeticsProductTypes constants`
      : `argument category is undefined`

    console.error(`Error in getCosmeticsCategories helper: ${error}`)
  }

  return isExist
}


type GetCosmeticsSubcategoriesInput = {
  root: RootName
  subCategories: SubCategory[]
  types: Type[]
}

/**
 * Get not empty subCategories for cosmetics pages
 */
const getCosmeticsSubcategories = (values: GetCosmeticsSubcategoriesInput): SubCategory[] => {
  const { subCategories, types, root } = values

  return subCategories.reduce((acc: SubCategory[], item) => {
    if (!item) {
      return acc
    }

    const isNotEmpty = Boolean(types[root].find(({ id }) => id === item.name))

    if (isNotEmpty) {
      acc.push(item)
    }

    return acc
  }, [])
}

type GetNotEmptyCosmeticsCategoriesInput = {
  root: RootName
  categories: Category[]
  types: Type[]
}


/**
 * Get not empty categories for cosmetics pages
 */
const getNotEmptyCosmeticsCategories = (values: GetNotEmptyCosmeticsCategoriesInput): Category[] => {
  const { categories, types, root } = values

  const isRootExist = checkRoot(root)

  if (!isRootExist) {
    return categories
  }

  return (
    categories.reduce((acc: Category[], item) => {
      if (!item) {
        return acc
      }

      const withSubCategories = Boolean(item.subCategories)

      // for items with subcategories
      if (withSubCategories) {
        const subCategories  = getCosmeticsSubcategories({ subCategories: item.subCategories, types, root })
        const isNotEmpty     = Boolean(subCategories.length)

        if (isNotEmpty) {
          acc.push({ ...item, subCategories })
        }

        return acc
      }

      // for items with name
      const category = Object.values(cosmeticsCategories[root].categories)
        .find((value) => value === item.name)

      const isCategoryExist = checkCategory(root, category)

      if (!isCategoryExist) {
        acc.push(item)

        return acc
      }

      let subCategories: SubCategory[]  = Object.values(cosmeticsProductTypes[root][category]).map((name: string) => ({ name }))
      subCategories                     = getCosmeticsSubcategories({ subCategories, types, root })
      const isNotEmpty                  = Boolean(subCategories.length)

      if (isNotEmpty) {
        acc.push(item)
      }

      return acc
    }, [])
  )
}


export default getNotEmptyCosmeticsCategories
